import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useUserStore } from '../stores/user'
import { filterAsyncRouter } from '../utils/router'
import Login from '../views/Login.vue'

// 基础路由（不需要权限）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/gateway-orders'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})

// 白名单路由
const whiteList = ['/login', '/404']

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  // 从 store 和 localStorage 双重检查token
  const token = userStore.token || localStorage.getItem('access_token')

  // 1. 白名单路由直接放行
  if (whiteList.includes(to.path) || to.meta.public) {
    next()
    return
  }

  // 2. 没有token，重定向到登录页
  if (!token) {
    // 确保清除所有状态
    userStore.clearToken()
    userStore.isRoutesLoaded = false
    next('/login')
    return
  }

  // 3. 已登录且已加载路由，直接放行
  if (userStore.isRoutesLoaded) {
    next()
    return
  }

  // 4. 已登录但未加载路由，获取用户信息和菜单并生成动态路由
  try {
    await userStore.fetchUserInfo()
    const menus = await userStore.fetchUserMenus()

    if (menus.length === 0) {
      // 没有菜单权限，登出并提示
      await userStore.logout()
      alert('您没有访问权限')
      next('/login')
      return
    }

    // 生成动态路由
    const asyncRoutes = filterAsyncRouter(menus)

    // 添加404兜底路由（指向网关订单页，实际由菜单路径命中）
    asyncRoutes.push({
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../views/gateway/order/index.vue'),
      meta: { hidden: true }
    })

    // 动态添加路由
    asyncRoutes.forEach(route => {
      router.addRoute(route)
    })

    // 标记路由已加载
    userStore.isRoutesLoaded = true

    // 重新导航到目标路由
    next({ ...to, replace: true })
  } catch (error) {
    console.error('加载动态路由失败:', error)
    await userStore.logout()
    next('/login')
  }
})

// 路由后置守卫（可选：用于页面标题、埋点等）
router.afterEach((to) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - JDY Pay` : 'JDY Pay'
})

export default router
